import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposComorbidades } from './tipos_comorbidades_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposComorbidadesListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_COMORBIDADES, paginaPermissao: FUNCIONALIDADES.TIPOS_COMORBIDADES, rota: ROUTES.TIPOS_COMORBIDADES, fetchData: function (str, _filter, pag) { return getTiposComorbidades(str, pag); }, columns: COLUNAS }));
}
export default TiposComorbidadesListar;
